import {
  useQuery, useMutation, useQueryClient 
} from '@tanstack/react-query';
import {
  getPrepLists,
  getBatchPlans,
  createBatchPlan,
  type PrepListFilters,
  type BatchPlanFilters,
  type CreateBatchPlanInput,
} from '../api';

export function usePrepLists(siteId: string, filters?: PrepListFilters) {
  return useQuery({
    queryKey: ['prep-lists', siteId, filters],
    queryFn: () => getPrepLists(siteId, filters),
    enabled: Boolean(siteId),
  });
}

export function useBatchPlans(siteId: string, filters?: BatchPlanFilters) {
  return useQuery({
    queryKey: ['batch-plans', siteId, filters],
    queryFn: () => getBatchPlans(siteId, filters),
    enabled: Boolean(siteId),
  });
}

export function useCreateBatchPlan(siteId: string) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (input: CreateBatchPlanInput) => createBatchPlan(siteId, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batch-plans', siteId] });
    },
  });
}
